<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Consultas de Placa">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Consulta</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
          
            <!--
            <b-col cols="auto">
                <b-form-group>
                    <label for="name" style="font-size: 0.8em">Filtro</label>
                    <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
                </b-form-group>
            </b-col>
            -->

            <b-col cols="auto">
              <b-form-group>
                  <label for="configuration" style="font-size: 0.8em">Praça</label>
                  <b-form-select id="configuration"
                    v-model="filters.configurationId"
                    :plain="true"
                    :options="selectConfigDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
                <b-form-group>
                    <label for="name" style="font-size: 0.8em">Pista</label>
                    <b-form-input v-model="filters.lane" type="text" id="lane" placeholder=""></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
                <b-form-group>
                    <label for="name" style="font-size: 0.8em">Placa</label>
                    <b-form-input class="text-uppercase" v-model="filters.plate" type="text" id="plate" placeholder=""></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="auto">
                <b-form-group>
                    <label for="startDate" style="font-size: 0.8em">Período</label>
                <b-form-input v-model="filters.startDate" type="date" id="startDate"></b-form-input>
            </b-form-group>
            </b-col>

            <b-col cols="auto">
                <b-form-group>
                    <label for="startDate">&nbsp;&nbsp;&nbsp;</label>
                        <b-form-input v-model="filters.endDate" type="date" id="endDate"></b-form-input>
                </b-form-group>
            </b-col>
        
            <!--
          <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Ativo/Inativo</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
            -->

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
  
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                      <b-row v-if="row.item.description">
                            <b-col>Descrição: <b>{{ row.item.description }}</b></b-col>
                        </b-row>
  
                    </b-card>
                </template>
                                        
                <template v-slot:cell(createdIn)="data">
                    {{ $utils.localDateTime( data.item.createdIn ) }}
                </template>

                <template v-slot:cell(status)="data">
                    {{ statusDDL.find(obj => parseInt(obj.value) === data.item.status).text }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Configuração"
              size="lg">
  
              <b-card> 

                <b-form @submit.stop.prevent="onSubmit">

                    <div class="animated fadeIn">

                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Praça"
                                label-for="plaza"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-input class="text-uppercase" v-model="plaza" id="plaza" type="text" placeholder=""></b-form-input>
                            </b-form-group> 
                            </b-form>
                            </b-col>
                        </b-row>

                        
                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Pista"
                                label-for="lane"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-input v-model="lane" id="lane" type="number" placeholder=""></b-form-input>
                            </b-form-group> 
                            </b-form>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Placa"
                                label-for="plate"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-input class="text-uppercase" v-model="plate" id="plate" type="text" placeholder=""></b-form-input>
                                
                            </b-form-group> 
                            </b-form>
                            </b-col>
                        </b-row>
                            
                        <b-input-group class="mb-4">
                            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                        </b-input-group>
                        
                    </div>
                </b-form>

                <div slot="footer" class="text-right">
                    <b-button variant="github" class="mr-1 btn-brand" @click="getMdfeByPlate()"><i class="fa fa-check"></i><span>Consultar Placa</span></b-button>
                </div>
                    
                </b-card>

      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: '', licensedUntil: null}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {

        appCode: 'WS',
        appName: 'sgap-protocol',
        plaza: '191',
        lane: 4,
        plate: '',
        errorMessage: '',
        mdfeModal: false,


        configDDL: [],
        certificateDDL: [],
        ufDDL: [],
        environmentDDL: [],

        statusDDL: [
            {
                text: 'Sem Manifesto',
                value: 0
            },
            {
                text: 'Com Manifesto',
                value: 1
            },
            {
                text: 'Offline',
                value: 2
            }
        ],

        directionDDL: [
            {
                text: 'Entrada',
                value: 1
            },
            {
                text: 'Saída',
                value: 2
            },
            {
                text: 'Indeterminado',
                value: 3
            }
        ],

        equipmentDDL: [
            {
                text: 'SLD',
                value: 1
            },
            {
                text: 'OCR',
                value: 2
            }
        ],

        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
      
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
       editModal: false,
        filters: {
          key: '',
          status: 'A',
          configurationId: 0,
          plaza: 0,
          lane: '',
          plate: '',
          startDate: '',
          endDate: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          {key: 'appName', label: 'Aplicação', sortable: true },
          {key: 'configuration.name', label: 'Praça', sortable: true },
          {key: 'lane', label: 'Pista', sortable: true  },
          {key: 'plate', label: 'Placa', sortable: true  }, 
          {key: 'createdIn', label: 'Data', sortable: true  }, 
          {key: 'status', label: 'Status', sortable: true  },   
          //{key: 'st', label: 'Ativo', sortable: true, thStyle: { width: "40px" }, class: 'text-center' },
          //{ key: 'action', label: 'Ações', sortable: false, thStyle: { width: "90px" } , class: 'text-center'}
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },

      selectConfigDDL: function() {
        var list = [...this.configDDL]
        list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
        list.unshift({ value: '0' , text: '- Todos -' })
        return list
      },

      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.plate == '' || (
                    this.$utils.filterString(item.plate, this.filters.plate)                
                  ))
                  && (this.filters.lane == '' || (
                    this.$utils.filterString(item.lane, this.filters.lane)
                  ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )    
          
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
        async postMdfeByPlate() {
            
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            //console.log(this.$store.state.ws_url + "/mdfe?appName=" + s.appName + "&appCode=" + s.appCode + "&plaza=" + s.plaza + "&lane=" + s.lane + "&plate=" + s.plate);


            await axios.get(
                this.$store.state.ws_url + "/mdfe?appName=" + s.appName + "&appCode=" + s.appCode + "&plaza=" + s.plaza + "&lane=" + s.lane + "&plate=" + s.plate
            ).then(function(resp) {
                console.log(resp)   
                s.errorMessage = 'Consulta realizada com sucesso para a placa: ' + s.plate.toUpperCase()
                s.plate = ''
                s.refreshData()
            })            
            .catch(function(error) {
                console.log(error)
                s.errorMessage = 'Erro ao realizar consulta por placa.'
            });
            
        },
        getMdfeByPlate() {
            if(this.plate && this.plate.length >= 7) {
                this.postMdfeByPlate()
                this.errorMessage = ''
            }
            else {
                this.errorMessage = 'Favor preencher os campos obrigatórios.'
                toast ({
                    type: VueNotifications.types.error,
                    title: 'MDFe',
                    message: 'Favor preencher os campos obrigatório.',
                    timeout: 3000
                })
            }
        },
    

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },
  
      async saveItem(currentItem) {
  
        var s = this;
        var postData = {...currentItem};
  
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid
  
        await axios.post(
            this.$store.state.ws_url + "/mdfe",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
  
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
  
    },
  
    save() {
  
        let msgError = [];
  
           if(!this.selectedItem.name || this.selectedItem.name.length <= 2)
            msgError.push("Cpnfiguração");
        
        if(!this.selectedItem.plaza || this.selectedItem.plaza.length <= 2)
            msgError.push("Praça");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )
  
            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },
  
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
     
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.clearSelectedRows();
            this.openEditModal(item);
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      async getConfig() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        //console.log(this.$store.state.ws_url + "/mdfe/configuration/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid)
        await axios.get(
            this.$store.state.ws_url + "/mdfe/configuration/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.configDDL = resp.data.obj
        }).catch(function(error) {
            console.log(error)
        })

      },
      async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        this.isBusy = true;

        await axios.get(
            this.$store.state.ws_url + "/mdfe/requests?configurationId=" + s.filters.configurationId 
            + "&plaza=" + s.filters.plaza 
            + "&lane=" + s.filters.lane 
            + "&startDate=" + s.filters.startDate 
            + "&endDate=" + s.filters.endDate 
            + "&uid=" + currentUser.id 
            + "&sid=" + currentUser.sid
        ).then(function (resp) {
            s.items = resp.data.obj;
        }
        ).catch(function (error) {
            console.log("ERRO")
            console.log(error.message);
            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: 'Sem permissão de acesso. Verifique e tente novamente.',
                timeout: 3000
            })
        });

        this.isBusy = false;
        
      },
      changeCompany() {
        this.refreshData();
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      var now = new Date();
      this.filters.startDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth() - 3, 1))
      this.filters.endDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth() + 1, 0))
      this.getConfig()
      this.changeCompany()
      
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>